export default __webpack_public_path__ + "static/media/The Storm.7b650c68.mp3";